import _ from 'lodash'

export const hasAccess = (userRole, { module, group, method }) => {
  return _.includes(
    userRole?.modules,
    _.find(userRole?.modules, {
      module,
      group,
      permissions: { [method]: true },
    }),
  )
}

export const hasAccessModule = (userRole, moduleToCheck) => {
  return (
    userRole?.modules?.some((item) => {
      if (item.module === moduleToCheck) {
        return Object.values(item.permissions).some((value) => value === true)
      }
      return false
    }) || false
  )
}
